import { render, staticRenderFns } from "./loyalty.vue?vue&type=template&id=55377f42&scoped=true&"
import script from "./loyalty.vue?vue&type=script&lang=js&"
export * from "./loyalty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55377f42",
  null
  
)

export default component.exports